import React from "react";
import { View } from "react-native";
import ActivityIndicatorLoader from "./ActivityIndicatorLoader";
import StyleSheet from "react-native-media-query";
import { theme } from "../../theme/theme";

const FullScreenLoader = ({ screenName, downloadLoader }: { screenName: string, downloadLoader?:boolean|any }) => (
  <View style={styles.loader} dataSet={{ media: ids.loader }}>
    <ActivityIndicatorLoader data={{ screenName, downloadLoader:downloadLoader }} indicator={true} />
  </View>
);

export default FullScreenLoader;

const { ids, styles } = StyleSheet.create({
  container: { alignItems: "center", justifyContent: "center" },
  loader: {
    display: "flex",
    flex: 1,

    position: "absolute",
    top: theme.spacing.none,
    bottom: theme.spacing.none,
    left: theme.spacing.none,
    right: theme.spacing.none,
    height: "110%",
    backgroundColor: theme.colors.loaderBg,
  },
});
